var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 38,
    viewBox: "0 0 50 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.75C0 3.33203 2.73438 0.5 6.25 0.5H43.75C47.168 0.5 50 3.33203 50 6.75V31.75C50 35.2656 47.168 38 43.75 38H6.25C2.73438 38 0 35.2656 0 31.75V6.75ZM4.6875 6.75V8.99609L21.4844 22.7656C23.5352 24.4258 26.3672 24.4258 28.418 22.7656L45.3125 8.99609V6.75C45.3125 5.96875 44.5312 5.1875 43.75 5.1875H6.25C5.37109 5.1875 4.6875 5.96875 4.6875 6.75ZM4.6875 15.0508V31.75C4.6875 32.6289 5.37109 33.3125 6.25 33.3125H43.75C44.5312 33.3125 45.3125 32.6289 45.3125 31.75V15.0508L31.4453 26.3789C27.6367 29.5039 22.2656 29.5039 18.457 26.3789L4.6875 15.0508Z",
    fill: "url(#paint0_linear_189_337)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_337",
    x1: 25,
    y1: -6,
    x2: 25,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7B7A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope-icon.0e93544ee9e3fd04f31137c092daa5c4.svg";
export { ForwardRef as ReactComponent };